import Vue from 'vue';
import App from './App';
import { router } from './router';

import store from './store' 
import {Overlay,Form,Empty,Divider, Collapse, CollapseItem ,Dialog,Slider,Stepper,Field,CellGroup,Cell,Button, Row,Icon,NavBar,Toast,Checkbox, CheckboxGroup,PasswordInput,NumberKeyboard,
  CountDown,Tabbar, TabbarItem,Grid, GridItem,Step, Steps,List,Tag,Uploader,Picker,Popup,Switch, RadioGroup, Radio,Tab, Tabs,Sticky,DatetimePicker  } from 'vant'
//Vue
Vue.use(Field).use(CellGroup).use(Cell)
.use(Overlay)
.use(Form)
.use(Sticky)
.use(Empty)
.use(DatetimePicker)
.use(Button)
.use(Tab)
.use(Tabs)
.use(Row)
.use(Icon)
.use(NavBar)
.use(Toast)
.use(Checkbox)
.use(CheckboxGroup)
.use(PasswordInput)
.use(NumberKeyboard)
.use(CountDown)
.use(Tabbar)
.use(TabbarItem)
.use(Grid)
.use(GridItem)
.use(Step)
.use(Steps)
.use(List)
.use(Tag)
.use(Uploader)
.use(Picker)
.use(Popup)
.use(Switch)
.use(Stepper)
.use(Slider)
.use(RadioGroup)
.use(Radio)
.use(Dialog)
.use(CollapseItem)
.use(Collapse)
.use(Divider )
import './asset/css/public.less';
import common from './utils/common';

// import VideoPlayer from 'vue-video-player';
// window.videojs = VideoPlayer.videojs
// require('video.js/dist/video-js.css')
// import './asset/css/custom-theme.css'
// Vue.use(VideoPlayer);


import htmlToPdf from '@/utils/htmlToPdf'
Vue.use(htmlToPdf)


Vue.prototype.common = common


new Vue({
  store ,
  router,
  el: '#app',
  render: h => h(App)
});
